import React from 'react';
import { View, StyleSheet } from 'react-native';
import { DrawerNavigationProp } from '@react-navigation/drawer';
import { useNavigation } from '@react-navigation/native';
import { Components, Theme } from '@oneamerica/dxp-ui-components';
import responsiveStyle from '../../style';
import RouteConstants from '../../../../constants/RouteConstants';
import { usePolicyDetailsSelector } from '../../../PolicyDetails/hooks/policyDetails';
import { trackCustomEvent } from '../../../../utils/Analytics/AdobeAnalyticsUtils';
import { analyticsTags } from '../../../../utils/Analytics/AnalyticsTags';

export const AdditionalDetailCard = ({ row, ...props }) => {
  const style = responsiveStyle();
  const navigation = useNavigation<DrawerNavigationProp<any>>();
  const {
    viewIndexedDividendData,
    coverageInformationData,
    premiumData,
    getPremiumStatus,
    incomeInformation,
    incomePaymentInformationData,
    ltcSectionData,
    freeWithdrawalData,
    annuityRatesData,
    allowFinancialActivities,
  } = usePolicyDetailsSelector(props);
  const detailLinks = [
    'ANNUITY RATES',
    'CASH WITHDRAWAL VALUES',
    'COVERAGE INFORMATION',
    'INCOME INFORMATION',
    'INCOME PAYMENT INFORMATION',
    'INDEXED DIVIDEND INFORMATION',
    'LTC VALUES',
    'PREMIUMS RECEIVED',
    'RECENT TRANSACTION HISTORY',
  ];
  const trackCustomEventHandler = (detailLinks) => {
    if (detailLinks === 'INDEXED DIVIDEND INFORMATION') {
      trackCustomEvent(analyticsTags.CaptureViewIndexedDividendTags);
    } else if (detailLinks === 'COVERAGE INFORMATION') {
      trackCustomEvent(analyticsTags.CaptureCoverageInformationTags);
    } else if (detailLinks === 'INCOME PAYMENT INFORMATION') {
      trackCustomEvent(analyticsTags.CaptureIncomePaymentInformationTags);
    } else if (detailLinks === 'INCOME INFORMATION') {
      trackCustomEvent(analyticsTags.CaptureIncomeInformationTags);
    } else if (detailLinks === 'PREMIUMS RECEIVED') {
      trackCustomEvent(analyticsTags.CapturePremiumReceivedValueTags);
    } else if (detailLinks === 'LTC VALUES') {
      trackCustomEvent(analyticsTags.CaptureLTCValueTags);
    } else if (detailLinks === 'CASH WITHDRAWAL VALUES') {
      trackCustomEvent(analyticsTags.CaptureCashWithdrawalValuesTags);
    } else if (detailLinks === 'ANNUITY RATES') {
      trackCustomEvent(analyticsTags.CaptureAnnuityRatesTags);
      navigateToPolicyDetails('AnnuityRates');
    } else if (detailLinks === 'RECENT TRANSACTION HISTORY') {
      trackCustomEvent(analyticsTags.CaptureRecentTransactionHistoryTags);
      navigateToPolicyDetails('RecentTransactionHistory');
    }
  };

  const linkStyles = {
    linkHoverStyle: StyleSheet.flatten([
      style.additionalDetailLink,
      { marginBottom: 0 },
    ]),
    hoverStyle: style.additionalDetailLink,
    linkStyle: style.additionalDetailLink,
    focusStyle: StyleSheet.flatten([
      style.cardActionButtonFocus,
      { marginBottom: Theme.Metrics.medium },
    ]),
  };
  const navigateToPolicyDetails = (cardName: string) => {
    if (cardName === 'RecentTransactionHistory') {
      navigation.navigate(RouteConstants.policyfinancials, {
        target: cardName,
      });
    } else {
      navigation.navigate(RouteConstants.policydetails, { target: cardName });
    }
  };

  const linkComponent = (item, policyDetailsCard) => {
    return (
      <Components.Link
        key={item}
        accessibilityLabel={item}
        accessibilityRole="button"
        {...linkStyles}
        onPress={() => {
          trackCustomEventHandler(item);
          navigateToPolicyDetails(policyDetailsCard);
        }}
      >
        {item}
      </Components.Link>
    );
  };

  return (
    <View className={props.className}>
      <View style={[style.cardShadow, row > 1 && style.flex]}>
        <View style={style.cardHeader}>
          <Components.Text.H3 style={[style.cardHeaderTitle, style.flex]}>
            Additional Details
          </Components.Text.H3>
        </View>
        <View className="mt-4" style={style.horizontalDivider} />
        <View className="mt-4">
          {detailLinks.map((item) => {
            const booleanMapping = {
              'PREMIUMS RECEIVED':
                getPremiumStatus === 'Active' && premiumData?.length > 0,
              'INDEXED DIVIDEND INFORMATION':
                viewIndexedDividendData?.length > 0,
              'INCOME PAYMENT INFORMATION':
                incomePaymentInformationData?.length > 0,
              'COVERAGE INFORMATION': coverageInformationData.length > 0,
              'LTC VALUES': ltcSectionData.length > 0,
              'INCOME INFORMATION': incomeInformation.length > 0,
              'CASH WITHDRAWAL VALUES': freeWithdrawalData.length > 0,
              'ANNUITY RATES': annuityRatesData?.length > 0,
              'RECENT TRANSACTION HISTORY': allowFinancialActivities,
            };

            const linkMapping = {
              'PREMIUMS RECEIVED': 'PremiumReceived',
              'INDEXED DIVIDEND INFORMATION': 'ViewIndexedDividend',
              'INCOME PAYMENT INFORMATION': 'IncomePaymentInformation',
              'COVERAGE INFORMATION': 'CoverageInformation',
              'LTC VALUES': 'PolicyValue',
              'INCOME INFORMATION': 'IncomeInformation',
              'CASH WITHDRAWAL VALUES': 'PolicyValue',
              'ANNUITY RATES': 'AnnuityRates',
              'RECENT TRANSACTION HISTORY': 'RecentTransactionHistory',
            };

            if (booleanMapping[item]) {
              return linkComponent(item, linkMapping[item]);
            }
            return null;
          })}
        </View>
      </View>
    </View>
  );
};
